import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function NotFoundPhase({ barcode, canCreate, onNo, onYes }) {
  const { t } = useTranslation('inventory');

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2, pt: 4 }}>
      <Alert severity="warning" sx={{ fontSize: '1rem' }}>
        {t(canCreate ? 'inventory:scanner.not_found_message' : 'inventory:scanner.not_found_plain', { barcode })}
      </Alert>
      {canCreate && <Button
        variant="contained"
        startIcon={<AddIcon />}
        size="large"
        onClick={onYes}
        fullWidth
        sx={{ minHeight: 52, fontSize: '1.05rem' }}
      >
        {t('inventory:scanner.create_item')}
      </Button>}
      <Button variant="outlined" size="large" onClick={onNo} fullWidth sx={{ minHeight: 52, fontSize: '1.05rem' }}>
        {t('inventory:scanner.scan_again')}
      </Button>
    </Box>
  );
}
